import React from "react";
import { ArrowLeft, Building2 } from "lucide-react";

type IconType = React.ElementType;

interface PageHeaderProps {
  readonly title: string;
  readonly Icon?: IconType;
  readonly onBack?: () => void;
  readonly className?: string;
}

export function PageHeader({
  title,
  Icon = Building2,
  onBack,
  className = "",
}: PageHeaderProps) {
  const handleBack = () => {
    if (onBack) return onBack();
    return globalThis.history.back();
  };

  return (
    <header
      className={`sticky top-0 z-30 bg-white/95 backdrop-blur-sm border-b border-black/[0.06] ${className}`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3.5 flex items-center gap-3">
        <button
          onClick={handleBack}
          className="w-8 h-8 rounded-lg bg-black/[0.03] border border-black/[0.06] flex items-center justify-center hover:bg-black/[0.06] transition-colors"
        >
          <ArrowLeft className="w-4 h-4 text-neutral-500" />
        </button>
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-[9px] bg-accent-800/[0.06] border border-accent-800/[0.08] flex items-center justify-center">
            <Icon className="w-4 h-4 text-accent-800" />
          </div>
          <h1 className="text-sm font-bold text-neutral-800">{title}</h1>
        </div>
      </div>
    </header>
  );
}

export default PageHeader;
